module.exports = __webpack_public_path__ + "static/fertility-9435487f98518091e5a63519aa7b36e9.png";